module.exports = function tools(elementId) {
  return {
    merge,
    listToDict,
    uniqueId,
    unique,
    isObject,
    isMicrosoftBrowser,
    isFieldVisible,
    getState,
    isFieldEnabled,
    findStateProperties,
    getFieldsOnPage,
    isFieldOnCurrentPage,
    getUrlParameters,
    range,
    parsePage,
    isCode,
    evaluate,
    makeGlobalState,
    ageFromDate,
    ageFromDateFull,
    isNumber,
    between,
    isEnclosedInTags,
    getIn,
    assocIn,
    parseJSON,
    isDev,
    updateIn,
  };

  function isMicrosoftBrowser() {
    var lookFor = [/trident/i, /edge/i];
    return lookFor.reduce((matched, regex) => {
      return matched || navigator.userAgent.match(regex);
    }, false);
  }

  // Calculates age from 6-digit date (ddmmyy).
  function ageFromDate(value, id) {
    let year;

    if (id === 'swedish_age') year = Number(value.slice(0, 2));
    else year = Number(value.slice(4, 6));

    var currentYear = Number(String(new Date().getFullYear()).slice(2, 4));
    var age = 100 + currentYear - year;
    var assumedAge = age > 100 ? age - 100 : age;
    return assumedAge;
  }

  // Calculates age from 8-digit date (ddmmyyyy) with full year.
  // Use this instead of ageFromDate when birthdate uses full year format.
  function ageFromDateFull(value) {
    var day = Number(value.slice(0, 2));
    var month = Number(value.slice(2, 4));
    var year = Number(value.slice(4, 8));
    var today = new Date();
    var age = today.getFullYear() - year;
    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day))
      age--;
    return age;
  }

  function between(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function randomUniqueId() {
    var time = new Date().getTime().toString(36).substr(2);

    return (time + '-' + randomString()).toUpperCase();

    function randomString(length = 7) {
      if (length === 0) return '';
      else {
        var randomCharacter = Math.round(Math.random() * 35).toString(36);
        return randomCharacter + randomString(length - 1);
      }
    }
  }

  function uniqueId(id) {
    return String(elementId) + '-' + id;
  }

  function merge(...objects) {
    var left = objects[0];
    if (objects.length === 1) return left;
    else if (objects.length === 0) return null;

    var right = merge.apply(null, objects.slice(1));
    var bothObjects = [left, right].every(isObject);
    if (right === null || left === null) return right;
    else if (bothObjects) return mergeObjects(left, right);
    else return right !== undefined ? right : left;
  }

  function mergeObjects(left, right) {
    var merged = {},
      key;
    for (key in left) {
      merged[key] = left[key];
    }
    for (key in right) {
      if (merged[key] === undefined) merged[key] = right[key];
      else merged[key] = merge(merged[key], right[key]);
    }
    return merged;
  }

  function isObject(value) {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
  }

  function getSelectedTab(state) {
    var tabField = state.fields.find((field) => field.config.behaviour === 'tabs');
    if (tabField !== undefined) {
      return tabField.config.options.find((option) => option.value === tabField.state.value) || {};
    } else return {};
  }

  function findStateProperties(state, property) {
    var matchingOptions = state.fields.map((field) => {
      var isEnabled = isFieldEnabled(state, field);
      if (!isEnabled) return [];
      else {
        return (field.config.options || [])
          .map((option) => {
            const propertyValue = option[property];
            if (matchesState(field.state.value, option.value) && propertyValue !== undefined) {
              return {
                value: propertyValue,
                priority: option.priority || 0,
              };
            }
          })
          .filter((a) => a !== undefined);
      }
    });
    return unique([].concat(...matchingOptions))
      .sort((a, b) => {
        return b.priority - a.priority;
      })
      .map((a) => a.value);
  }

  function unique(list) {
    var map = list.reduce((map, item) => {
      map[item] = item;
      return map;
    }, {});
    return Object.keys(map).map((key) => map[key]);
  }

  function getActiveField(state, id) {
    return state.fields.find((field) => {
      return field.config.id === id && isFieldEnabled(state, field);
    });
  }

  function getState(state, id) {
    var field = getActiveField(state, id);
    return field ? field.state.value : null;
  }

  function getFullState(state, id) {
    var field = getActiveField(state, id);
    return field ? field.state : null;
  }

  function getFullConfig(state, id) {
    var field = getActiveField(state, id);
    return field ? field.config : null;
  }

  function wrapInArray(input) {
    if (Array.isArray(input)) return input;
    else return [input];
  }

  function matchesState(state, match) {
    var matches = wrapInArray(match).reduce((list, item) => {
      if (Array.isArray(item)) return list.concat(range.apply(null, item));
      else return list.concat(item);
    }, []);

    return (
      wrapInArray(state).filter((s) => {
        return matches.map(String).indexOf(s) !== -1;
      }).length !== 0
    );
  }

  function range(start, stop, step) {
    if (step === 0) return [];
    if (step === undefined) step = start < stop ? 1 : -1;

    var range = [];
    var i = start;
    while (step > 0 ? i <= stop : i >= stop) {
      range.push(String(i));
      i += step;
    }
    return range;
  }

  function isFieldEnabled(state, field) {
    if (field.state.enabled === null) {
      var currentTab = getSelectedTab(state).value;
      var tabSetting = field.config.tabs;
      var enabled =
        parseShow(field.config.show) &&
        parseHide(field.config.hide) &&
        (tabSetting === undefined || tabSetting.indexOf(currentTab) !== -1);
      field.state.enabled = enabled;
    }
    return field.state.enabled;

    function parseHide(hide) {
      if (hide === undefined) return true;
      else {
        return !parseShow(hide);
      }
    }

    function parseShow(show) {
      if (!show) return true;
      else {
        if (Array.isArray(show)) {
          return show.reduce((bool, value) => {
            return bool || parseShowObject(value);
          }, false);
        } else return parseShowObject(show);
      }
    }

    function parseShowObject(show) {
      return Object.keys(show).reduce((bool, key) => {
        var actualState = getState(state, key);
        var specifiedState = show[key];

        if (typeof specifiedState === 'string' && isCode(specifiedState)) {
          return bool && evaluate(specifiedState, state, field);
        } else return bool && matchesState(actualState, specifiedState);
      }, true);
    }
  }

  function isCode(text) {
    return text.match(/^\([\s\S]{1,}\)$/);
  }

  function makeGlobalState(state, globalConfig) {
    const fields = state.fields.filter((f) => f.id !== undefined);

    var globalState = fields.reduce((dict, field) => {
      dict[field.id] = getState(state, field.id);
      return dict;
    }, {});

    globalState.fullState = fields.reduce((dict, field) => {
      dict[field.id] = getFullState(state, field.id);
      return dict;
    }, {});
    globalState.fullConfig = fields.reduce((dict, field) => {
      dict[field.id] = getFullConfig(state, field.id);
      return dict;
    }, {});

    globalState.globalConfig = globalConfig;

    return globalState;
  }

  function evaluate(text, state) {
    return runEvaluate(text, state);
  }

  function getFieldsOnPage(state, pageNumber, recursive = true) {
    return state.fields.filter((field) => {
      var config = field.config;
      var pageConfig =
        config.page === 'last' && recursive ? parsePage(state, config.page) : config.page;
      return (
        isFieldEnabled(state, field) &&
        !config.invisible &&
        (pageConfig === undefined || pageConfig === pageNumber)
      );
    });
  }

  function parsePage(state, page, lastPage = state.pages.config.numberOfPages) {
    if (page === 'last') {
      var fields = getFieldsOnPage(state, lastPage, false);
      if (lastPage === 0 || fields.length > 0) return lastPage;
      return parsePage(state, page, lastPage - 1);
    } else return page;
  }

  function isFieldVisible(state, field) {
    var config = field.config;
    return isFieldOnCurrentPage(state, field) && !config.invisible;
  }

  function isFieldOnCurrentPage(state, field) {
    var currentPage = state.pages.state.value;
    var config = field.config;
    var pageSetting = config.ignorePage || parsePage(state, field.config.page);

    return (
      isFieldEnabled(state, field) &&
      (pageSetting === true || pageSetting === undefined || pageSetting === currentPage)
    );
  }

  function listToDict(list, key = 'id') {
    return list.reduce((dict, item) => {
      dict[item[key]] = item;
      return dict;
    }, {});
  }

  function getUrlParameters() {
    var parameterString = window.location.search;
    var splitParametersRegex = /(\?|&)/;
    var removeSeparatorsRegex = /(?=[^&])(?=[^?])/;

    var parameterArray = parameterString.split(splitParametersRegex);
    return parameterArray
      .filter(function removeSeparators(urlParameter) {
        return urlParameter.match(removeSeparatorsRegex);
      })
      .reduce(function joinKeysWithValues(dict, parameter) {
        var keysAndValues = parameter.split('=');
        dict[keysAndValues[0]] = decodeURIComponent(keysAndValues[1]);
        return dict;
      }, {});
  }

  function isNumber(format) {
    var numberFormats = ['integer'];
    return numberFormats.indexOf(format) !== -1;
  }
};

function isEnclosedInTags(text) {
  return text.match(/^<[\s\S]*>$/);
}

function runEvaluate(text, __incoming_state) {
  var state = __incoming_state.globalState;
  var numbers = Object.keys(state).reduce((map, key) => {
    var number = Number(state[key]);
    if (number === number) {
      map[key] = number;
    }
    return map;
  }, {});
  const getNumber = (key, fallback = 0) => {
    const number = numbers[key];
    if (number !== undefined) return number;
    else return fallback;
  };
  var res = eval(text);
  // console.log(numbers.total_loan_amount, numbers.total_collateral, numbers.loan_collateral_ratio);
  return res;
}

function getUrlParameters() {
  return window.location.search.split(/\?|&/).reduce((params, parameter) => {
    var [key, value] = parameter.split('=');
    if (value !== undefined) params[key] = decodeURIComponent(value);
    return params;
  }, {});
}

function isDev() {
  return process.env.NODE_ENV === 'development';
}

function getIn(dict, [key, ...rest]) {
  if (key === null || key === undefined) return undefined;
  else if (dict[key] === undefined) return undefined;
  else if (rest.length === 0) return dict[key];
  else return getIn(dict[key], rest);
}

function assocIn(dict, [key, ...rest], value) {
  if (key === null || key === undefined) {
    return;
  } else if (rest.length === 0) {
    dict[key] = value;
  } else {
    assocIn(dict[key], rest, value);
  }
}
function updateIn(dict, [key, ...rest], fun = (a) => a) {
  if (key === null || key === undefined) return;
  else if (rest.length === 0) dict[key] = logicalTrue(fun(dict[key]), dict[key]);
  else updateIn(dict[key], rest, fun);

  function logicalTrue(val, fallback) {
    if (val === undefined || val === null || val !== val) return fallback;
    else return val;
  }
}
function parseJSON(json) {
  try {
    if (json.indexOf(")]}',") === 0) return JSON.parse(json.slice(5));
    else return JSON.parse(json);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
